<template>
  <div>
    <head-bottom />
    <div
      class="air"
    >
      <div class="container">
        <div class="air-cards">
          <div class="air-cards-left">
            <p
              v-if="businessClub[0].title"
              class="air-cards-left__title"
              v-html="businessClub[0].title"
            />
          </div>
          <div class="air-cards-right">
            <img
              v-if="businessClub[0].icon"
              src="../assets/images/businessClub.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  <div class="container">
    <p
      v-if="businessClub[0].description"
      class="air-cards-left__sub"
       v-html="businessClub[0].description"
    />
      <div
        v-if="sub_cats.insuranceObject"
        class="object"
      >
        <p
          v-if="sub_cats.insuranceObject.title"
          class="object-title"
          v-html="sub_cats.insuranceObject.title"
        />
        <p
          v-if="sub_cats.insuranceObject.description"
          class="object-desc"
          v-html="sub_cats.insuranceObject.description"
        />
       <div v-for="(item, idx) in sub_cats.insuranceObject.sub_cats" :key="idx">
        <p
          v-if="item.title"
          class="object-title"
          v-html="item.title"
        />
        <p
          v-if="item.description"
          class="object-desc"
          v-html="item.description"
        />
        <div class="par" v-for="(item2, idx2) in item.cats" :key="idx2">
          <span>0{{idx2+1}}.</span>
          <p
            v-if="item2.title"
            class="object-par"
            v-html="item2.title"
          ></p>
         </div>
      </div>
      <div
        v-if="sub_cats.insuranceRisks"
        class="risk"
      >
        <p
          v-if="sub_cats.insuranceRisks.title"
          class="risk-title"
          v-html="sub_cats.insuranceRisks.title"
        />
        <p
          v-if="sub_cats.insuranceRisks.description"
          class="object-desc"
          v-html="sub_cats.insuranceRisks.description"
        />
        <div v-for="(item, idx) in sub_cats.insuranceRisks.sub_cats" :key="idx">
          <p
            v-if="item.title"
            class="object-title"
            v-html="item.title"
          />
          <p
            v-if="item.description"
            class="object-desc"
            v-html="item.description"
          />
          <div class="par" v-for="(item2, idx2) in item.cats" :key="idx2">
            <span v-if="idx2 < 9">0{{idx2+1}}.</span>
            <span v-else>{{idx2+1}}.</span>
            <p
              v-if="item2.title"
              class="object-par"
              v-html="item2.title"
            ></p>
          </div>
      </div>
      </div>
      <div
        v-if="sub_cats.insuranceRisks"
        class="risk"
      >
        <p
          v-if="sub_cats.insurancePeriod.title"
          class="risk-title"
          v-html="sub_cats.insurancePeriod.title"
        />
        <p
          v-if="sub_cats.insurancePeriod.description"
          class="object-desc"
          v-html="sub_cats.insurancePeriod.description"
        />
        <div v-for="(item, idx) in sub_cats.insurancePeriod.sub_cats" :key="idx">
          <p
            v-if="item.title"
            class="object-title"
            v-html="item.title"
          />
          <div
            v-if="item.description"
            class="object-desc"
            v-html="item.description"
          />
          <div class="par" v-for="(item2, idx2) in item.cats" :key="idx2">
            <span v-if="idx2 < 9">0{{idx2+1}}.</span>
            <span v-else>{{idx2+1}}.</span>
            <p
              v-if="item2.title"
              class="object-par"
              v-html="item2.title"
            ></p>
          </div>
        </div>
      </div> 
    </div>
    <!-- <div class="time-btn">
      <time-btn :p_name="p_name" />
    </div> -->

      <accordion />
    
    <question/>
    <!-- <question :p_name="p_name" /> -->
    <slider-main-1 class="m_none" />
    <slider-main-mobile class="d_none" />
  </div>
  </div>
</template>

<script>
import Question from "../components/Question.vue";
import HeadBottom from "../components/HeadBottom.vue";
import SliderMain1 from "../components/SliderMain1-1.vue";
import SliderMainMobile from "@/components/SliderMainMobile.vue";
import accordion from "../components/accordion.vue";
import timeBtn from "../components/timeBtn.vue";
import PolisButton from "@/components/PolisButton.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: {
    HeadBottom,
    Question,
    SliderMain1,
    SliderMainMobile,
    accordion,
    PolisButton,
    timeBtn,
  },
  data() {
    return {
      p_name: "Страхование воздушного транспорта",
      businessClub: [],
      sub_cats: {},
      timeTitle: [],
      timeDesc: [],
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  created() {
    axios
      .get("V1/yourBusinessClub")
      .then((response) => {
        this.businessClub = response.data.data;
        let insuranceObject = response.data.data.filter(item => item.type.toLowerCase() === "объекты страхования" && item.id !== 1);
        let insuranceRisks = response.data.data.filter(item => item.type.toLowerCase() === "страховые риски" && item.id !== 1);
        let insurancePeriod = response.data.data.filter(item => item.type.toLowerCase() === "срок страхования" && item.id !== 1);
        
        this.sub_cats = {
          insuranceObject: {
            title: insuranceObject[0].title, 
            description: insuranceObject[0].description,
            sub_cats: [
              {
              title: insuranceObject.filter((item, idx) => item.id === 10)[0].title, 
              description: insuranceObject.filter((item, idx) => item.id === 10)[0].description,
              cats: insuranceObject.filter((item, idx) => item.id === 11 || item.id === 12)
              },
              {
              title: insuranceObject.filter((item, idx) => item.id === 13)[0].title, 
              description: insuranceObject.filter((item, idx) => item.id === 13)[0].description,
              cats: insuranceObject.filter((item, idx) => item.id === 14)
              },
              {
              title: insuranceObject.filter((item, idx) => item.id === 15)[0].title, 
              description: insuranceObject.filter((item, idx) => item.id === 15)[0].description,
              cats: insuranceObject.filter((item, idx) => item.id === 16)
              }
            ],
          },
          insuranceRisks: {
            title: insuranceRisks[0].title, 
            description: insuranceRisks[0].description,
            sub_cats: [
              {
              title: insuranceRisks.filter((item, idx) => item.id === 10)[0]?.title, 
              description: insuranceRisks.filter((item, idx) => item.id === 10)[0]?.description,
              cats: insuranceRisks.filter((item, idx) => item.id >= 18 && item.id <= 29)
              }
            ],
          }, 
          insurancePeriod: {
            title: insurancePeriod[0].title, 
            description: insurancePeriod[0].description,
            sub_cats: [
              {
              title: insurancePeriod.filter((item, idx) => item.id === 31)[0]?.title, 
              description: insurancePeriod.filter((item, idx) => item.id === 31)[0]?.description,
              cats: []
              },
              {
              title: insurancePeriod.filter((item, idx) => item.id === 32)[0]?.title, 
              description: insurancePeriod.filter((item, idx) => item.id === 32)[0]?.description,
              cats: []
              }
            ],
          }, 
          // insurancePeriod: {
          //   title: insurancePeriod[0].title, 
          //   description: insurancePeriod[0].description,
          //   cats: insurancePeriod
          // }
        };
        // this.timeTitle = response.data.data[0].sub_cats[3].title;
        // this.timeDesc = response.data.data[0].sub_cats[3].desc;
      })
      .catch((e) => {
        console.log(e);
        // this.errors.push(e);
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/timeBtn.scss";
@media (max-width: 976px) {
  .d__none {
    display: inline !important;
  }
  .air {
    background-image: none !important;
  }
}
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 768px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 768px) and (max-width: 1024px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1024px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1441px) and (max-width: 2560px) {
    @content;
  }
}
.d__none {
  display: none;
}
.par {
  display: flex;
  margin-top: 15px;
  align-items: center;
}
.air {
  background: #efefef;
  // background-image: url(../assets/images/businessClub.png);
  // background-position-y: 20%;
  background-repeat: no-repeat;
  // background-size: auto;
  padding-top: 80px;
  padding-bottom: 86px;
  &-cards {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      width: 50%;
      &__title {
        @include fontStyle(Roboto, normal, 500, 36px, 43px, transparent);
        letter-spacing: 0.03em;
        text-transform: uppercase;
        background: linear-gradient(
          90deg,
          #ff143f 0%,
          #c600dd 49.97%,
          #1b27ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      &__sub {
        @include fontStyle(Roboto, normal, 400, 24px, 36px, #373737);
        text-transform: uppercase;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      &__btn,
      &__btn-mob {
        button {
          background: #ffffff;
          border-radius: 15px;
          width: 200px;
          height: 70px;
          border: none;
          color: #373737;
          @include fontStyle(Roboto, normal, 600, 18px, 25px, #373737);
          &:hover {
            background: linear-gradient(
              90deg,
              #ff4466 0%,
              #be31ce 49.97%,
              #3641ff 100%
            );
            color: #ffffff;
          }
        }
      }
      &__btn-mob {
        margin: 0 auto;
        text-align: center;
      }
    }
    &-right {
      width: 45%;
      img {
        width: 100%;
      }
    }
  }
  @include mobile() {
    padding-top: 25px;
    padding-bottom: 20px;
    &-cards {
      flex-wrap: wrap;
      &-left {
        // margin: 0 auto;
        &__title {
          width: 100%;
          font-size: 14px;
          line-height: 17px;
        }
        &__sub {
          font-size: 12px;
          line-height: 14px;
          padding-top: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
        &__btn-mob {
          text-align: center;
          button {
            border-radius: 3px;
            width: 96px;
            height: 28px;
            font-size: 9px;
          }
        }
      }
      &-right {
        img {
          width: 75%;
          margin: 0 auto;
          display: flex;
          transform: inherit;
        }
      }
    }
  }
  @include tablet() {
    &-cards {
      flex-wrap: wrap;
      &-left {
        &__title {
          width: 100%;
          font-size: 22px;
          line-height: 24px;
        }
        &__sub {
          font-size: 16px;
          line-height: 22px;
        }
        &__btn {
          text-align: center;
          button {
            border-radius: 3px;
            width: 116px;
            height: 38px;
            font-size: 10px;
          }
        }
      }
      &-right {
        img {
          margin-top: 10px;
          width: 100%;
        }
      }
    }
  }
  @include tablet-1024() {
    padding-bottom: 50px;
    &-cards {
      &-right {
        img {
          width: 100%;
        }
      }
      &-left {
        &__title {
          font-size: 20px;
          line-height: 25px;
        }
        &__sub {
          font-size: 14px;
          line-height: 20px;
        }
        &__btn {
          button {
            width: 170px;
            height: 50px;
            border-radius: 7px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
.object {
  padding-bottom: 55px;
  @include mobile() {
    padding-top: 25px;
    padding-bottom: 20px;
  }
  @include tablet() {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  @include tablet-1024() {
    padding-top: 40px;
    padding-bottom: 25px;
  }
}
.object,
.risk {
  &-title {
    @include fontStyle(Roboto, normal, 500, 28px, 34px, #373737);
    margin-bottom: 0;
    text-transform: uppercase;
    margin-top: 15px;
  }
  &-desc {
    @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    margin-bottom: 0;
    margin-top: 10px;
    ::v-deep table td {
      padding: 10px;
    }
  }
  &-par {
    @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    margin-bottom: 0;
    span {
      @include fontStyle(Roboto, normal, 900, 24px, 33px, #ffffff);
      letter-spacing: 0.03em;
      background: -webkit-linear-gradient(
        180deg,
        #1b27ff 39%,
        #c600dd 44%,
        #ff143f 69%
      );
      -webkit-background-clip: text;
      -webkit-text-stroke: 2px transparent;
      color: #ffffff;
      padding-right: 10px;
      padding-left: 2px;
    }
  }
  span {
    @include fontStyle(Roboto, normal, 900, 24px, 33px, #ffffff);
    letter-spacing: 0.03em;
    background: -webkit-linear-gradient(
      180deg,
      #1b27ff 61%,
      #c600dd 30%,
      #ff143f 81%
    );
    -webkit-background-clip: text;
    -webkit-text-stroke: 2px transparent;
    color: #ffffff;
    padding-right: 10px;
    padding-left: 2px;
  }
  @include mobile() {
    &-title {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    &-par {
      font-size: 12px;
      line-height: 14px;
      // margin-top: -10px;
      padding-bottom: 7px;
      span {
        font-size: 12px;
        line-height: 14px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
    span {
      font-size: 10px;
      line-height: 12px;
      font-weight: 700;
      -webkit-text-stroke: 1px transparent;
    }
  }
  @include tablet() {
    &-title {
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
    }
    &-par {
      font-size: 12px;
      line-height: 14px;
      // margin-top: -10px;
      padding-bottom: 7px;
      span {
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
    span {
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
      -webkit-text-stroke: 1px transparent;
    }
  }
  @include tablet-1024() {
    &-title {
      font-size: 20px;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      padding-bottom: 10px;
    }
    &-par {
      font-size: 14px;
      line-height: 14px;
      padding-bottom: 10px;
      span {
        font-size: 14px;
        line-height: 18px;
        font-weight: 700;
        -webkit-text-stroke: 1px transparent;
      }
    }
    span {
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
      -webkit-text-stroke: 1px transparent;
    }
  }
  @include desktop() {
    &-title {
      padding-bottom: 10px;
    }
  }
  @include desktop-max() {
    &-title {
      padding-bottom: 10px;
    }
  }
}
</style>
